import { AxiosResponse } from 'axios';
import { MediaResponse } from '../types/media';
import { getApiUrl } from '../util/util';
import { get, post } from './http';

interface MediaApi {
	uploadFile(
		authorizationToken: string,
		file: File,
	): Promise<AxiosResponse<MediaResponse>>;
	getFile(
		authorizationToken: string,
		locator: string,
	): Promise<AxiosResponse<MediaResponse>>;
}

export default {
	uploadFile(authorizationToken: string, file: File) {
		const formData = new FormData();
		formData.append('file', file);
		formData.append('fileName', file.name);
		return post(
			`${getApiUrl()}/document/v1/media`,
			authorizationToken,
			formData,
		);
	},

	getFile(authorizationToken: string, locator: string) {
		return get(
			`${getApiUrl()}/document/v1/media/${locator}`,
			authorizationToken,
		);
	},
} as MediaApi;
